module.exports = require('./bundle-url').getBundleURL() + "plockletutorial2.839b4801.jpg"